<template>
  <div class="reservation-box">
    <menuBox :step="4"></menuBox>
    <div class="content-top">
      <div class="title">Chính sách bảo mật</div>
      <div class="text">Tìm hiểu về Chính sách bảo mật của VayDễ</div>
    </div>
    <div class="content">
      <p class="western" align="center"
        style="line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto;margin-bottom: 20px;">
        <font size="4" style="font-size: 14pt"><span lang="en-US"><b>chính
              sách bảo mật</b></span></font>
      </p>
      <p class="western" align="left"
        style="line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto">
        <font face="Times New Roman, serif">
          <font size="2" style="font-size: 9pt"><span lang="en-US"><span style="font-weight: normal">VayDễ
                (sau đây gọi tắt là “chúng tôi” hoặc “ứng dụng
                này”) là nền tảng cung cấp dịch vụ cho vay tài chính.
                Nhà phát triển VayDễ là PT STARKA PRO INDONESIA. Chính sách
                quyền riêng tư này thông báo cho bạn về việc chúng tôi
                thu thập, sử dụng và tiết lộ dữ liệu cá nhân khi bạn
                sử dụng Ứng dụng của chúng tôi hoặc bất kỳ dịch
                vụ nào được cung cấp trong đó, cũng như các lựa chọn
                bạn có liên quan đến dữ liệu cá nhân của mình. Chúng
                tôi sử dụng dữ liệu cá nhân của bạn để cung cấp
                và cải thiện trải nghiệm của bạn trên Ứng dụng và
                Dịch vụ của chúng tôi. Bằng việc sử dụng Ứng dụng
                và Dịch vụ, bạn đồng ý với việc thu thập và sử
                dụng thông tin theo Chính sách này. Vì vậy, vui lòng đọc
                kỹ chính sách quyền riêng tư này để hiểu rõ hơn về
                cách chúng tôi sử dụng và bảo vệ thông tin của bạn.</span></span></font>
        </font>
      </p>
      <p class="western" align="left"
        style="font-weight: normal; line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto">
        <br />

      </p>
      <p class="western" align="left"
        style="line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto">
        <font face="Times New Roman, serif">
          <font size="2" style="font-size: 9pt"><span lang="en-US"><b>(1).</b></span></font>
        </font>
        <font face="Times New Roman, serif">
          <font size="2" style="font-size: 9pt"><span lang="en-US"><b>Hiểu
                rõ thông tin được thu thập từ người dùng</b></span></font>
        </font>
      </p>
      <p class="western" align="left"
        style="line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto">
        <font face="Times New Roman, serif">
          <font size="2" style="font-size: 9pt"><span lang="en-US"><span style="font-weight: normal">1.
              </span></span></font>
        </font>
        <font face="Times New Roman, serif">
          <font size="2" style="font-size: 9pt"><span lang="en-US"><b>Thông
                tin nhận dạng cá nhân</b></span></font>
        </font>
        <font face="Times New Roman, serif">
          <font size="2" style="font-size: 9pt"><span lang="en-US"><span style="font-weight: normal">:
                Khi người dùng đăng ký hoặc đăng nhập vào nền tảng
                VayDễ, để xác minh danh tính người dùng và đảm bảo
                tính bảo mật cho tài khoản của bạn, chúng tôi sẽ thu
                thập một số thông tin cá nhân như tên, giới tính, CMND,
                thông tin thẻ ngân hàng, ngày sinh, ảnh, trình độ học
                vấn, thông tin liên lạc (bao gồm địa chỉ nhà, địa
                chỉ email và số điện thoại di động) và tình trạng
                hôn nhân. Thông tin này sẽ được sử dụng để nhận
                dạng và bảo vệ khỏi nguy cơ gian lận.</span></span></font>
        </font>
      </p>
      <p class="western" align="left"
        style="font-weight: normal; line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto">
        <br />

      </p>
      <p class="western" align="left"
        style="line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto">
        <font face="Times New Roman, serif">
          <font size="2" style="font-size: 9pt"><span lang="en-US"><span style="font-weight: normal">2.
              </span></span></font>
        </font>
        <font face="Times New Roman, serif">
          <font size="2" style="font-size: 9pt"><span lang="en-US"><b>Thông
                tin danh sách liên hệ</b></span></font>
        </font>
        <font face="Times New Roman, serif">
          <font size="2" style="font-size: 9pt"><span lang="en-US"><span style="font-weight: normal">:
                Khi bạn đăng ký khoản vay trên nền tảng VayDễ, VayDễ
                cần thu thập, truyền tải và lưu trữ thông tin danh sách
                liên hệ của bạn, bao gồm tên, số điện thoại và
                thông tin liên hệ của người liên hệ. Điều này chủ
                yếu là để cung cấp cho bạn. chọn một liên hệ trong
                sổ địa chỉ làm liên hệ khẩn cấp, chúng tôi sẽ
                không có được sự cho phép này. Chúng tôi bảo vệ
                nghiêm ngặt quyền riêng tư và bảo mật của bạn và
                thông tin thu thập được sẽ được tải lên
                https://ynvonk.borrowdong24online.com. Bạn có thể yêu cầu
                chúng tôi xóa dữ liệu liên quan bất cứ lúc nào. VayDễ
                cam kết bảo vệ an toàn dữ liệu của mọi người dùng.</span></span></font>
        </font>
      </p>
      <p class="western" align="left"
        style="font-weight: normal; line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto">
        <br />

      </p>
      <p class="western" align="left"
        style="line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto">
        <font face="Times New Roman, serif">
          <font size="2" style="font-size: 9pt"><span lang="en-US"><span style="font-weight: normal">3.
              </span></span></font>
        </font>
        <font face="Times New Roman, serif">
          <font size="2" style="font-size: 9pt"><span lang="en-US"><b>Thông
                tin tài chính</b></span></font>
        </font>
        <font face="Times New Roman, serif">
          <font size="2" style="font-size: 9pt"><span lang="en-US"><span style="font-weight: normal">:
                Để kiểm tra tốt hơn tình hình tài chính của bạn và
                giúp đánh giá mức độ tín nhiệm của bạn, chúng tôi
                cần thu thập: thông tin thanh toán, chẳng hạn như thông
                tin tài khoản thanh toán và ủy quyền thanh toán, bao gồm
                số thẻ ngân hàng của người dùng. Để sau khi người
                dùng hoàn thành việc đánh giá tín dụng, bộ phận sản
                phẩm cho vay có thể chuyển số tiền bạn đã đăng ký
                vào tài khoản của mình thông qua thông tin tài chính mà
                bạn cung cấp.</span></span></font>
        </font>
      </p>
      <p class="western" align="left"
        style="font-weight: normal; line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto">
        <br />

      </p>
      <p class="western" align="left"
        style="line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto">
        <font face="Times New Roman, serif">
          <font size="2" style="font-size: 9pt"><span lang="en-US"><span style="font-weight: normal">4.
              </span></span></font>
        </font>
        <font face="Times New Roman, serif">
          <font size="2" style="font-size: 9pt"><span lang="en-US"><b>Thông
                tin camera</b></span></font>
        </font>
        <font face="Times New Roman, serif">
          <font size="2" style="font-size: 9pt"><span lang="en-US"><span style="font-weight: normal">:
                Khi bạn đăng ký vay trên Vay Nhanh, bạn cần tải lên hình
                ảnh và dữ liệu khuôn mặt. Thông tin này chỉ được
                ứng dụng thu thập nhằm giúp chúng tôi xác nhận danh
                tính của người dùng. Chúng tôi sẽ không có được sự
                cho phép này. dữ liệu sẽ được Mã hóa và tải lên
                trung tâm bảo mật của chúng tôi tại
                https://ynvonk.borrowdong24online.com và không bao giờ được
                chia sẻ với bên thứ ba.</span></span></font>
        </font>
      </p>
      <p class="western" align="left"
        style="font-weight: normal; line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto">
        <br />

      </p>
      <p class="western" align="left"
        style="line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto">
        <font face="Times New Roman, serif">
          <font size="2" style="font-size: 9pt"><span lang="en-US"><span style="font-weight: normal">5.
              </span></span></font>
        </font>
        <font face="Times New Roman, serif">
          <font size="2" style="font-size: 9pt"><span lang="en-US"><b>Thông
                tin hình ảnh</b></span></font>
        </font>
        <font face="Times New Roman, serif">
          <font size="2" style="font-size: 9pt"><span lang="en-US"><span style="font-weight: normal">:
                Khi người dùng liên hệ bộ phận chăm sóc khách hàng và
                cần tải ảnh lên để báo sự cố, VayDễ cần chọn ảnh
                tải lên trong album để đảm bảo tính toàn vẹn của
                chức năng. Nhưng chúng tôi không được phép chụp ảnh,
                chúng tôi chỉ vào album để chọn ảnh. Thông tin này sẽ
                không được sử dụng cho các mục đích khác mà không có
                sự cho phép của bạn. Chúng tôi sẽ mã hóa tất cả
                thông tin thu thập được và tải lên trung tâm bảo mật
                https://ynvonk.borrowdong24online.com của chúng tôi để đảm
                bảo tính bảo mật của thông tin.</span></span></font>
        </font>
      </p>
      <p class="western" align="left"
        style="font-weight: normal; line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto">
        <br />

      </p>
      <p class="western" align="left"
        style="line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto">
        <font face="Times New Roman, serif">
          <font size="2" style="font-size: 9pt"><span lang="en-US"><span style="font-weight: normal">6.
              </span></span></font>
        </font>
        <font face="Times New Roman, serif">
          <font size="2" style="font-size: 9pt"><span lang="en-US"><b>Thông
                tin SMS</b></span></font>
        </font>
        <font face="Times New Roman, serif">
          <font size="2" style="font-size: 9pt"><span lang="en-US"><span style="font-weight: normal">:
                Khi bạn sử dụng dịch vụ mượn trên VayDễ, VayDễ cần
                thu thập, truyền và lưu trữ thông tin SMS của người
                dùng, bao gồm tiêu đề và số SMS, v.v. sau khi được
                người dùng ủy quyền. Xin lưu ý rằng chúng tôi sẽ chỉ
                lấy thông tin đã lọc. tin nhắn SMS. Điều này chủ yếu
                là để đánh giá tín dụng của người dùng và tiến
                hành phân tích chống lừa đảo để đảm bảo tính bảo
                mật cho tài khoản của người dùng. Thông tin này sẽ
                không được sử dụng cho các mục đích khác mà không có
                sự cho phép của bạn và sẽ được mã hóa và tải lên
                trung tâm bảo mật https://ynvonk.borrowdong24online.com của
                chúng tôi để đảm bảo tính bảo mật của thông tin.
                Tất nhiên, bạn có thể yêu cầu chúng tôi xóa dữ liệu
                liên quan bất cứ lúc nào.</span></span></font>
        </font>
      </p>
      <p class="western" align="left"
        style="font-weight: normal; line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto">
        <br />

      </p>
      <p class="western" align="left"
        style="line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto">
        <font face="Times New Roman, serif">
          <font size="2" style="font-size: 9pt"><span lang="en-US"><span style="font-weight: normal">7.
              </span></span></font>
        </font>
        <font face="Times New Roman, serif">
          <font size="2" style="font-size: 9pt"><span lang="en-US"><b>Danh
                sách ứng dụng đã cài đặt</b></span></font>
        </font>
        <font face="Times New Roman, serif">
          <font size="2" style="font-size: 9pt"><span lang="en-US"><span style="font-weight: normal">:
                VayDễ sẽ thu thập và tải lên danh sách ứng dụng phi hệ
                thống đã cài đặt trên thiết bị của bạn (bao gồm
                tên ứng dụng, thời gian cài đặt ứng dụng, thời gian
                cập nhật ứng dụng, v.v.) khi bạn gửi đơn vay và phân
                tích Danh sách ứng dụng của người dùng. các ứng dụng
                đã cài đặt, xác định các mối đe dọa bảo mật tiềm
                ẩn và phân tích các tùy chọn hành vi để kiểm tra chống
                gian lận nhằm đảm bảo sử dụng ứng dụng an toàn.
                Chúng tôi sẽ tải thông tin này lên
                https://ynvonk.borrowdong24online.com để mã hóa và sẽ không
                bao giờ tiết lộ nếu không có sự cho phép của người
                dùng.</span></span></font>
        </font>
      </p>
      <p class="western" align="left"
        style="font-weight: normal; line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto">
        <br />

      </p>
      <p class="western" align="left"
        style="line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto">
        <font face="Times New Roman, serif">
          <font size="2" style="font-size: 9pt"><span lang="en-US"><span style="font-weight: normal">8.</span></span>
          </font>
        </font>
        <font face="Times New Roman, serif">
          <font size="2" style="font-size: 9pt"><span lang="en-US"><b>
                ID quảng cáo Google(GAID)</b></span></font>
        </font>
        <font face="Times New Roman, serif">
          <font size="2" style="font-size: 9pt"><span lang="en-US"><span style="font-weight: normal">:
                Khi bạn sử dụng dịch vụ của nền tảng VayDễ, chúng
                tôi sẽ thu thập ID quảng cáo Google của bạn nhằm mục
                đích tối ưu hóa và phân tích các quảng cáo của chúng
                tôi. Đồng thời, việc hiển thị được cá nhân hóa
                được thực hiện dựa trên hành vi và sở thích của bạn
                để cải thiện trải nghiệm và sự hài lòng của bạn.</span></span></font>
        </font>
      </p>
      <p class="western" align="left"
        style="font-weight: normal; line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto">
        <br />

      </p>
      <p class="western" align="left"
        style="line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto">
        <font face="Times New Roman, serif">
          <font size="2" style="font-size: 9pt"><span lang="en-US"><span style="font-weight: normal">9.</span></span>
          </font>
        </font>
        <font face="Times New Roman, serif">
          <font size="2" style="font-size: 9pt"><span lang="en-US"><b>Thông
                tin tài khoản mạng xã hội</b></span></font>
        </font>
        <font face="Times New Roman, serif">
          <font size="2" style="font-size: 9pt"><span lang="en-US"><span style="font-weight: normal">:
                Khi bạn đăng ký khoản vay trên VayDễ, VayDễ sẽ lấy
                được một số thông tin công khai từ tài khoản mạng xã
                hội của bạn sau khi được ủy quyền để cung cấp thêm
                các đề xuất nội dung được cá nhân hóa và xác minh
                danh tính người dùng cũng như liên hệ với người dùng
                để nâng cao tính tương tác Xã hội của ứng dụng.
                Chúng tôi sẽ mã hóa thông tin tài khoản xã hội của bạn
                và tải nó lên https://ynvonk.borrowdong24online.com.</span></span></font>
        </font>
      </p>
      <p class="western" align="left"
        style="font-weight: normal; line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto">
        <br />

      </p>
      <p class="western" align="left"
        style="line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto">
        <font face="Times New Roman, serif">
          <font size="2" style="font-size: 9pt"><span lang="en-US"><span style="font-weight: normal">10.</span></span>
          </font>
        </font>
        <font face="Times New Roman, serif">
          <font size="2" style="font-size: 9pt"><span lang="en-US"><b>
                Thông tin vị trí</b></span></font>
        </font>
        <font face="Times New Roman, serif">
          <font size="2" style="font-size: 9pt"><span lang="en-US"><span style="font-weight: normal">:
                Khi bạn sử dụng dịch vụ của VayDễ, chúng tôi sẽ lấy
                thông tin vị trí của bạn để phân tích kỹ thuật, tối
                ưu hóa hiển thị nội dung của chúng tôi và các dịch vụ
                được cá nhân hóa theo khu vực để cải thiện trải
                nghiệm và sự hài lòng của bạn. Xin lưu ý rằng chúng
                tôi sẽ chỉ nhận được vị trí mờ của người dùng.</span></span></font>
        </font>
      </p>
      <p class="western" align="left"
        style="font-weight: normal; line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto">
        <br />

      </p>
      <p class="western" align="left"
        style="line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto">
        <font face="Times New Roman, serif">
          <font size="2" style="font-size: 9pt"><span lang="en-US"><span style="font-weight: normal">11.
              </span></span></font>
        </font>
        <font face="Times New Roman, serif">
          <font size="2" style="font-size: 9pt"><span lang="en-US"><b>Thông
                tin thiết bị</b></span></font>
        </font>
        <font face="Times New Roman, serif">
          <font size="2" style="font-size: 9pt"><span lang="en-US"><span style="font-weight: normal">:
                Để cung cấp dịch vụ và hỗ trợ tốt hơn, VayDễ có
                thể lấy thông tin về thiết bị mà người dùng sử
                dụng, bao gồm model thiết bị, địa chỉ IP, loại trình
                duyệt, phiên bản hệ điều hành, nhà điều hành và nhà
                sản xuất, v.v. Thông tin này giúp chúng tôi hiểu hiệu
                suất và khả năng tương thích của thiết bị của bạn
                để đảm bảo rằng các ứng dụng của chúng tôi hoạt
                động bình thường trên thiết bị của bạn.</span></span></font>
        </font>
      </p>
      <p class="western" align="left"
        style="font-weight: normal; line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto">
        <br />

      </p>
      <p class="western" align="left"
        style="line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto">
        <font face="Times New Roman, serif">
          <font size="2" style="font-size: 9pt"><span lang="en-US"><b>(2).Giới
                thiệu chức năng APP</b></span></font>
        </font>
      </p>
      <p class="western" align="left"
        style="line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto">
        <font face="Times New Roman, serif">
          <font size="2" style="font-size: 9pt"><span lang="en-US"><span style="font-weight: normal">VayDễ
                là nền tảng dịch vụ tài chính đa chức năng được
                thiết kế nhằm cung cấp cho các cá nhân dịch vụ vay vốn
                nhanh chóng và tiện lợi. Các tính năng chính bao gồm:</span></span></font>
        </font>
      </p>
      <p class="western" align="left"
        style="line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto">
        <font face="Times New Roman, serif">
          <font size="2" style="font-size: 9pt"><span lang="en-US"><span style="font-weight: normal">Đăng
                ký nhanh chóng: Người dùng có thể đăng ký vay trực
                tuyến mọi lúc mọi nơi, đơn giản hóa các thủ tục
                rườm rà.</span></span></font>
        </font>
      </p>
      <ul>
        <li>
          <p class="western" align="left"
            style="line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto">
            <font face="Times New Roman, serif">
              <font size="2" style="font-size: 9pt"><span lang="en-US"><span style="font-weight: normal">Phê
                    duyệt theo thời gian thực: Thông qua công nghệ kiểm soát
                    rủi ro tiên tiến, đạt được phê duyệt cấp hai để
                    đảm bảo rằng người dùng có thể nhận được tiền
                    kịp thời.</span></span></font>
            </font>
          </p>
        </li>
        <li>
          <p class="western" align="left"
            style="line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto">
            <font face="Times New Roman, serif">
              <font size="2" style="font-size: 9pt"><span lang="en-US"><span style="font-weight: normal">Trả
                    nợ linh hoạt: Cung cấp nhiều phương thức trả nợ đa
                    dạng, cho phép người dùng lựa chọn phương án trả nợ
                    phù hợp nhất với mình.</span></span></font>
            </font>
          </p>
        </li>
        <li>
          <p class="western" align="left"
            style="line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto">
            <font face="Times New Roman, serif">
              <font size="2" style="font-size: 9pt"><span lang="en-US"><span style="font-weight: normal">Thông
                    tin minh bạch: Mọi thông tin về khoản vay đều rõ ràng,
                    minh bạch, không có phí ẩn. Người dùng có thể kiểm
                    tra tình trạng khoản vay bất cứ lúc nào.</span></span></font>
            </font>
          </p>
        </li>
      </ul>
      <p class="western" align="left"
        style="font-weight: normal; line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto">
        <br />

      </p>
      <p class="western" align="left"
        style="line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto">
        <font face="Times New Roman, serif">
          <font size="2" style="font-size: 9pt"><span lang="en-US"><b>(3).Cách
                bảo vệ an toàn dữ liệu</b></span></font>
        </font>
      </p>
      <p class="western" align="left"
        style="line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto">
        <font face="Times New Roman, serif">
          <font size="2" style="font-size: 9pt"><span lang="en-US"><span style="font-weight: normal">Chúng
                tôi cố gắng đảm bảo tính bảo mật cho dữ liệu cá
                nhân của bạn thông qua các biện pháp bảo mật nội bộ
                và thực thi chính sách nghiêm ngặt, cũng như các biện
                pháp và kiểm soát an ninh mạng thích hợp để đảm bảo
                tính bảo mật, tính toàn vẹn và tính sẵn có của dữ
                liệu và thông tin cá nhân của bạn. Chúng tôi cũng yêu
                cầu nhân viên và nhà thầu bên thứ ba của mình tuân thủ
                các tiêu chuẩn và chính sách về quyền riêng tư hiện
                hành của chúng tôi cũng như phải thận trọng và hành
                động đúng mức khi sử dụng, gửi hoặc truyền dữ liệu
                cá nhân của bạn. Chúng tôi cũng sử dụng các công nghệ
                bảo mật tiên tiến để bảo vệ dữ liệu cá nhân của
                bạn, bao gồm nhưng không giới hạn ở: (1) phát hiện xâm
                nhập; (3) quét vi-rút; (4) Lớp cổng bảo mật (5) mã hóa
                dữ liệu; ) cookie; (7) Tự động đăng xuất.</span></span></font>
        </font>
      </p>
      <p class="western" align="left"
        style="font-weight: normal; line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto">
        <br />

      </p>
      <p class="western" align="left"
        style="line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto">
        <font face="Times New Roman, serif">
          <font size="2" style="font-size: 9pt"><span lang="en-US"><span style="font-weight: normal">Công
                ty coi trọng dữ liệu cá nhân được thu thập, sử dụng,
                lưu giữ và lưu trữ thông qua Ứng dụng và Công ty đã
                triển khai các biện pháp kỹ thuật, tổ chức và vật lý
                để bảo vệ Dữ liệu cá nhân của bạn. Mọi dữ liệu
                thu thập được sẽ được tải lên và lưu trữ tại
                https://ynvonk.borrowdong24online.com. Tất cả dữ liệu cá
                nhân do chúng tôi thu thập sẽ chỉ được lưu trữ trong
                cơ sở hạ tầng/lưu trữ/trung tâm dữ liệu đám mây
                trong phạm vi quyền hạn của Việt Nam. Chúng tôi chỉ
                truy cập và sử dụng dữ liệu cá nhân của bạn trong
                phạm vi cần thiết để cung cấp cho bạn các dịch vụ.</span></span></font>
        </font>
      </p>
      <p class="western" align="left"
        style="font-weight: normal; line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto">
        <br />

      </p>
      <p class="western" align="left"
        style="line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto">
        <font face="Times New Roman, serif">
          <font size="2" style="font-size: 9pt"><span lang="en-US"><span style="font-weight: normal">Chúng
                tôi sẽ sử dụng các tiêu chuẩn ngành được chấp nhận
                chung để bảo vệ thông tin người dùng gửi cho chúng
                tôi, cả trong quá trình truyền và sau khi nhận. Nhưng xin
                lưu ý rằng không có phương thức truyền qua Internet hoặc
                phương pháp lưu trữ điện tử nào an toàn 100%. Do đó,
                mặc dù chúng tôi cố gắng sử dụng các phương tiện
                được chấp nhận về mặt thương mại để bảo vệ
                thông tin người dùng, chúng tôi không thể đảm bảo tính
                bảo mật tuyệt đối của thông tin đó và việc sử dụng
                Ứng dụng của bạn hoàn toàn do bạn tự chịu rủi ro và
                tùy ý quyết định. Chúng tôi cũng không thể đảm bảo
                rằng thông tin người dùng đó sẽ không bị lạm dụng
                nếu các biện pháp bảo vệ và giao thức của chúng tôi
                bị bất kỳ bên thứ ba độc hại nào vi phạm. Ngoài ra,
                chúng tôi không chịu trách nhiệm và không thể kiểm soát
                hoàn toàn hành động của những người dùng khác mà bạn
                có thể chọn chia sẻ thông tin.</span></span></font>
        </font>
      </p>
      <p class="western" align="left"
        style="font-weight: normal; line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto">
        <br />

      </p>
      <p class="western" align="left"
        style="line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto">
        <font face="Times New Roman, serif">
          <font size="2" style="font-size: 9pt"><span lang="en-US"><b>(4).Cách
                sử dụng thông tin</b></span></font>
        </font>
      </p>
      <p class="western" align="left"
        style="line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto">
        <font face="Times New Roman, serif">
          <font size="2" style="font-size: 9pt"><span lang="en-US"><span style="font-weight: normal">Chúng
                tôi sẽ sử dụng thông tin cá nhân được thu thập cho
                các mục đích như tối ưu hóa chất lượng dịch vụ,
                cải thiện trải nghiệm người dùng và tăng cường bảo
                mật nền tảng. Đầu tiên, thông tin cá nhân được thu
                thập có thể giúp chúng tôi phân tích sở thích của
                người dùng và cải thiện chức năng ứng dụng. Ví dụ:
                hiểu thói quen sử dụng và các chức năng phổ biến của
                người dùng có thể giúp chúng tôi điều chỉnh bố cục
                giao diện và hợp lý hóa các bước thao tác trong quá
                trình cập nhật, mang lại trải nghiệm vận hành thân
                thiện hơn với người dùng. Thứ hai, dựa trên thông tin
                tài chính và dữ liệu tín dụng thu thập được, chúng
                tôi có thể cung cấp cho người dùng các sản phẩm tài
                chính và giải pháp đề xuất được cá nhân hóa hơn để
                mỗi người dùng có thể tìm thấy các dịch vụ phù hợp
                với nhu cầu của mình. Ngoài ra, để đảm bảo an toàn
                cho dữ liệu người dùng, chúng tôi sử dụng các dữ
                liệu như thông tin xác minh danh tính, thông tin thiết bị
                và vị trí để xác định và ngăn chặn các hành vi rủi
                ro có thể xảy ra cũng như đảm bảo tính bảo mật cho
                tài khoản người dùng. Thông qua dữ liệu như tin nhắn
                văn bản, hồ sơ cuộc gọi và thông tin xã hội, chúng
                tôi cũng có thể đánh giá toàn diện hơn trạng thái tín
                dụng của người dùng để cải thiện tính minh bạch và
                công bằng trong việc cho vay. Chúng tôi cam kết tuân thủ
                nghiêm ngặt chính sách quyền riêng tư trong mọi tình
                huống sử dụng để đảm bảo thông tin được bảo vệ
                đúng cách.</span></span></font>
        </font>
      </p>
      <p class="western" align="left"
        style="font-weight: normal; line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto">
        <br />

      </p>
      <p class="western" align="left"
        style="line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto">
        <font face="Times New Roman, serif">
          <font size="2" style="font-size: 9pt"><span lang="en-US"><b>(5).Cách
                lưu trữ thông tin người dùng</b></span></font>
        </font>
      </p>
      <ul>
        <li>
          <p class="western" align="left"
            style="line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto">
            <font face="Times New Roman, serif">
              <font size="2" style="font-size: 9pt"><span lang="en-US"><span style="font-weight: normal">Xử
                    lý tải lên dữ liệu: Dữ liệu được thu thập sẽ
                    được tải lên máy chủ của chúng tôi
                    (https://ynvonk.borrowdong24online.com) để mã hóa, truyền,
                    lưu trữ và xử lý;</span></span></font>
            </font>
          </p>
        </li>
        <li>
          <p class="western" align="left"
            style="line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto">
            <font face="Times New Roman, serif">
              <font size="2" style="font-size: 9pt"><span lang="en-US"><span style="font-weight: normal">Bảo
                    mật dữ liệu: Để bảo vệ tính bảo mật cho thông tin
                    của bạn, chúng tôi tích cực áp dụng nhiều biện pháp
                    bảo mật vật lý, điện tử và quản lý hợp lý theo
                    tiêu chuẩn ngành để bảo vệ thông tin của bạn để
                    thông tin của bạn không bị rò rỉ, hư hỏng hoặc bị
                    mất, bao gồm SSL và dữ liệu mã hóa. Lưu trữ, kiểm
                    soát truy cập trung tâm dữ liệu, v.v.</span></span></font>
            </font>
          </p>
        </li>
        <li>
          <p class="western" align="left"
            style="line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto">
            <font face="Times New Roman, serif">
              <font size="2" style="font-size: 9pt"><span lang="en-US"><span style="font-weight: normal">Bảo
                    mật dữ liệu: Chúng tôi sẽ không tiết lộ bất kỳ
                    thông tin nào chứa dữ liệu cá nhân cho bất kỳ bên thứ
                    ba nào mà không có sự cho phép của bạn và với sự
                    đồng ý của bạn, chúng tôi có thể cung cấp cho bên
                    thứ ba các sản phẩm hoặc dịch vụ mà bạn yêu cầu;</span></span></font>
            </font>
          </p>
        </li>
      </ul>
      <p class="western" align="left"
        style="font-weight: normal; line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto">
        <br />

      </p>
      <p class="western" align="left"
        style="line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto">
        <font face="Times New Roman, serif">
          <font size="2" style="font-size: 9pt"><span lang="en-US"><b>(6).Mục
                đích thu thập thông tin</b></span></font>
        </font>
      </p>
      <p class="western" align="left"
        style="line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto">
        ●<font face="Times New Roman, serif">
          <font size="2" style="font-size: 9pt"><span lang="en-US"><span style="font-weight: normal">Xác
                minh tính xác thực của danh tính và thông tin người dùng,
                đồng thời tiến hành phân tích rủi ro và tính khả thi
                của các khoản vay.</span></span></font>
        </font>
      </p>
      <p class="western" align="left"
        style="line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto">
        ●<font face="Times New Roman, serif">
          <font size="2" style="font-size: 9pt"><span lang="en-US"><span style="font-weight: normal">Để
                cung cấp và duy trì Dịch vụ của chúng tôi.</span></span></font>
        </font>
      </p>
      <p class="western" align="left"
        style="line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto">
        ●<font face="Times New Roman, serif">
          <font size="2" style="font-size: 9pt"><span lang="en-US"><span style="font-weight: normal">Gửi
                quảng cáo và ưu đãi dịch vụ để cung cấp cho bạn
                hàng hóa hoặc dịch vụ tương tự.</span></span></font>
        </font>
      </p>
      <p class="western" align="left"
        style="line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto">
        ●<font face="Times New Roman, serif">
          <font size="2" style="font-size: 9pt"><span lang="en-US"><span style="font-weight: normal">Quản
                lý ứng dụng/trang web của chúng tôi</span></span></font>
        </font>
      </p>
      <p class="western" align="left"
        style="line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto">
        ●<font face="Times New Roman, serif">
          <font size="2" style="font-size: 9pt"><span lang="en-US"><span style="font-weight: normal">Đáp
                ứng các nhu cầu vận hành và bảo trì của APP, chẳng
                hạn như phân tích dữ liệu, xếp hạng tín dụng của
                người dùng, phân tích hành vi người dùng, v.v. Để tạo
                điều kiện thuận lợi cho việc bảo trì hàng ngày của
                chúng tôi và cải thiện chất lượng dịch vụ.</span></span></font>
        </font>
      </p>
      <p class="western" align="left"
        style="line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto">
        ●<font face="Times New Roman, serif">
          <font size="2" style="font-size: 9pt"><span lang="en-US"><span style="font-weight: normal">Để
                điều tra và phát hiện các hành vi gian lận có thể xảy
                ra hoặc các vi phạm khác đối với Điều khoản và Điều
                kiện của chúng tôi hoặc Chính sách quyền riêng tư này,
                cũng như các nỗ lực gây hại cho người dùng hoặc khách
                truy cập của chúng tôi.</span></span></font>
        </font>
      </p>
      <p class="western" align="left"
        style="line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto">
        ●<font face="Times New Roman, serif">
          <font size="2" style="font-size: 9pt"><span lang="en-US"><span style="font-weight: normal">Thực
                hiện hiệu quả các hoạt động thu phí trực tiếp hoặc
                thông qua các công ty bên thứ ba được ủy thác cho chúng
                tôi.</span></span></font>
        </font>
      </p>
      <p class="western" align="left"
        style="line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto">
        ●<font face="Times New Roman, serif">
          <font size="2" style="font-size: 9pt"><span lang="en-US"><span style="font-weight: normal">Phát
                hiện, ngăn chặn và giải quyết các vấn đề kỹ thuật
                và cung cấp hỗ trợ khách hàng</span></span></font>
        </font>
      </p>
      <p class="western" align="left"
        style="font-weight: normal; line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto">
        <br />

      </p>
      <p class="western" align="left"
        style="line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto">
        <font face="Times New Roman, serif">
          <font size="2" style="font-size: 9pt"><span lang="en-US"><b>(7)</b></span></font>
        </font>
        <font face="Times New Roman, serif">
          <font size="2" style="font-size: 9pt"><span lang="en-US"><b>.Cookies</b></span></font>
        </font>
      </p>
      <p class="western" align="left"
        style="line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto">
        <font face="Times New Roman, serif">
          <font size="2" style="font-size: 9pt"><span lang="en-US"><span style="font-weight: normal">Để
                đảm bảo trang web hoạt động bình thường và hiệu quả,
                chúng tôi lưu trữ các tệp dữ liệu nhỏ gọi là cookie
                trên trình duyệt web hoặc ứng dụng di động của bạn.
                Nội dung của cookie chỉ có thể được truy xuất hoặc
                đọc bởi máy chủ đã tạo ra nó. Mỗi cookie là duy nhất
                cho trình duyệt web hoặc ứng dụng di động của bạn.
                Việc sử dụng cookie có thể giúp bạn tránh phải điền
                nhiều lần thông tin cá nhân, nhập nội dung tìm kiếm,
                các bước và quy trình (ví dụ: điền biểu mẫu, hồ sơ
                tìm kiếm). Bạn có thể quản lý hoặc xóa cookie theo sở
                thích của mình. Hầu hết các trình duyệt đều cung cấp
                cho người dùng chức năng xóa dữ liệu bộ nhớ đệm
                của trình duyệt. Bạn có thể thực hiện thao tác xóa dữ
                liệu tương ứng trong chức năng cài đặt trình duyệt.
                Tuy nhiên, bạn có thể không thể trải nghiệm đầy đủ
                một số tính năng dịch vụ tiện lợi và an toàn của
                chúng tôi.</span></span></font>
        </font>
      </p>
      <p class="western" align="left"
        style="font-weight: normal; line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto">
        <br />

      </p>
      <p class="western" align="left"
        style="line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto">
        <font face="Times New Roman, serif">
          <font size="2" style="font-size: 9pt"><span lang="en-US"><b>(8).Thay
                đổi chính sách quyền riêng tư</b></span></font>
        </font>
      </p>
      <p class="western" align="left"
        style="line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto">
        <font face="Times New Roman, serif">
          <font size="2" style="font-size: 9pt"><span lang="en-US"><span style="font-weight: normal">Đôi
                khi, chúng tôi có thể xem xét và sửa đổi Chính sách
                quyền riêng tư này theo quyết định riêng của mình để
                đảm bảo rằng nó phù hợp với sự phát triển trong
                tương lai và/hoặc những thay đổi của chúng tôi về các
                yêu cầu pháp lý hoặc quy định. Nếu chúng tôi quyết
                định sửa đổi Chính sách quyền riêng tư này, chúng tôi
                sẽ thông báo cho bạn về bất kỳ sửa đổi nào như vậy
                bằng cách đăng thông báo chung trên Ứng dụng và/hoặc
                Trang web hoặc gửi đến địa chỉ email được liệt kê
                trong tài khoản của bạn. Bạn đồng ý rằng bạn có
                trách nhiệm xem xét định kỳ Chính sách quyền riêng tư
                này để biết thông tin mới nhất về các biện pháp xử
                lý dữ liệu và bảo vệ dữ liệu của chúng tôi cũng
                như việc bạn tiếp tục sử dụng Ứng dụng hoặc Trang
                web, trao đổi thư từ với chúng tôi hoặc truy cập và sử
                dụng Dịch vụ sẽ cấu thành chấp nhận các sửa đổi.</span></span></font>
        </font>
      </p>
      <p class="western" align="left"
        style="font-weight: normal; line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto">
        <br />

      </p>
      <p class="western" align="left"
        style="line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto">
        <font face="Times New Roman, serif">
          <font size="2" style="font-size: 9pt"><span lang="en-US"><b>(9).Bảo
                vệ bản quyền trí tuệ</b></span></font>
        </font>
      </p>
      <p class="western" align="left"
        style="line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto">
        <font face="Times New Roman, serif">
          <font size="2" style="font-size: 9pt"><span lang="en-US"><span style="font-weight: normal">Dù
                có tuyên bố rõ ràng hay không, VayDễ sở hữu quyền sở
                hữu trí tuệ đối với tất cả thông tin thuộc phạm vi
                không công cộng và thông tin độc quyền của các bên
                khác trên nền tảng này, bao gồm nhưng không giới hạn ở
                nhãn hiệu, bằng sáng chế, bản quyền và bí mật thương
                mại. Thông tin này bao gồm văn bản, đồ họa, phần mềm,
                âm thanh, video, dữ liệu, mã nguồn, thiết kế nền tảng,
                công nghệ độc quyền, bố cục màn hình và thiết kế
                web. Người dùng có trách nhiệm tôn trọng quyền sở hữu
                trí tuệ. Nếu người sử dụng có hành vi xâm phạm, gây
                thiệt hại thì phải chịu mọi trách nhiệm trước pháp
                luật và chịu trách nhiệm trước VayDễ.</span></span></font>
        </font>
      </p>
      <p class="western" align="left"
        style="font-weight: normal; line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto">
        <br />

      </p>
      <p class="western" align="left"
        style="line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto">
        <font face="Times New Roman, serif">
          <font size="2" style="font-size: 9pt"><span lang="en-US"><b>(10).Quyền
                và nghĩa vụ của người dùng</b></span></font>
        </font>
      </p>
      <p class="western" align="left"
        style="line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto">
        <font face="Times New Roman, serif">
          <font size="2" style="font-size: 9pt"><span lang="en-US"><span style="font-weight: normal">Người
                dùng có quyền biết bất kỳ lúc nào liệu dữ liệu cá
                nhân của họ có được lưu trữ hay không và tham khảo ý
                kiến ​​của chúng tôi để tìm hiểu về nội dung và
                nguồn gốc của chúng, để xác minh tính chính xác của
                chúng hoặc yêu cầu bổ sung, hủy bỏ, cập nhật hoặc
                chỉnh sửa hoặc yêu cầu chuyển đổi chúng thành một
                định dạng ẩn danh hoặc để ngăn chặn mọi hành vi vi
                phạm Dữ liệu pháp lý và phản đối việc xử lý dữ
                liệu đó trên bất kỳ và tất cả các cơ sở hợp pháp.
                Yêu cầu phải được gửi cho chúng tôi bằng cách sử
                dụng thông tin liên hệ được liệt kê bên dưới. Xin
                lưu ý rằng việc xóa hoặc xóa thông tin có thể ảnh
                hưởng đến khả năng cung cấp dịch vụ của chúng tôi
                cho bạn.</span></span></font>
        </font>
      </p>
      <p class="western" align="left"
        style="line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto">
        <font face="Times New Roman, serif">
          <font size="2" style="font-size: 9pt"><span lang="en-US"><span style="font-weight: normal">Bạn
                có quyền:</span></span></font>
        </font>
      </p>
      <ul>
        <li>
          <p class="western" align="left"
            style="line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto">
            <font face="Times New Roman, serif">
              <font size="2" style="font-size: 9pt"><span lang="en-US"><span style="font-weight: normal">truy
                    cập dữ liệu cá nhân của bạn hoặc lấy bản sao dữ
                    liệu cá nhân của bạn khi sở hữu Ứng dụng;</span></span></font>
            </font>
          </p>
        </li>
        <li>
          <p class="western" align="left"
            style="line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto">
            <a name="_GoBack"></a>
            <font face="Times New Roman, serif">
              <font size="2" style="font-size: 9pt"><span lang="en-US"><span style="font-weight: normal">Rút
                    lại sự đồng ý xử lý dữ liệu cá nhân của bạn,
                    xem xét và/hoặc xóa dữ liệu cá nhân do Ứng dụng lưu
                    giữ, trừ khi việc lưu giữ dữ liệu nói trên là bắt
                    buộc theo luật pháp và quy định và trong mọi trường
                    hợp thu hồi, sửa đổi và xóa như vậy mà không có
                    hiệu lực hồi tố. không có nghĩa là không thể thực
                    hiện các nghĩa vụ phát sinh từ mối quan hệ pháp lý
                    hiện tại giữa bạn và ứng dụng này hoặc khi liên
                    quan đến các mục đích không thiết yếu.</span></span></font>
            </font>
          </p>
        </li>
      </ul>
      <p class="western" align="left"
        style="line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto">
        <font face="Times New Roman, serif">
          <font size="2" style="font-size: 9pt"><span lang="en-US"><span style="font-weight: normal">Việc
                thực hiện các quyền trên phải được thực hiện bằng
                văn bản qua email đến địa chỉ email sau:
                amanda@ptstarkapro.com. Sau khi đơn đăng ký được nộp theo
                các điều khoản trên, đơn đăng ký sẽ đưa ra quyết
                định được phê duyệt.</span></span></font>
        </font>
      </p>
      <p class="western" align="left"
        style="font-weight: normal; line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto">
        <br />

      </p>
      <p class="western" align="left"
        style="line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto">
        <font face="Times New Roman, serif">
          <font size="2" style="font-size: 9pt"><span lang="en-US"><span style="font-weight: normal">Bạn
                đồng ý thông báo cho chúng tôi ngay lập tức bằng văn
                bản và trong mọi trường hợp trong vòng 14 ngày theo lịch
                về bất kỳ thay đổi nào đối với thông tin bạn cung
                cấp cho chúng tôi tùy từng thời điểm và phản hồi kịp
                thời mọi yêu cầu từ chúng tôi khi:</span></span></font>
        </font>
      </p>
      <ul>
        <li>
          <p class="western" align="left"
            style="line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto">
            <font face="Times New Roman, serif">
              <font size="2" style="font-size: 9pt"><span lang="en-US"><span style="font-weight: normal">việc
                    bạn không cung cấp kịp thời bất kỳ thông tin người
                    dùng hoặc dữ liệu cá nhân nào mà chúng tôi yêu cầu
                    một cách hợp lý;</span></span></font>
            </font>
          </p>
        </li>
        <li>
          <p class="western" align="left"
            style="line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto">
            <font face="Times New Roman, serif">
              <font size="2" style="font-size: 9pt"><span lang="en-US"><span style="font-weight: normal">bạn
                    từ chối hoặc rút lại bất kỳ sự đồng ý nào mà
                    chúng tôi có thể cần để xử lý, chuyển giao hoặc
                    tiết lộ dữ liệu cá nhân cho các mục đích được nêu
                    ở trên trong chính sách này (ngoài các mục đích liên
                    quan đến tiếp thị hoặc quảng bá sản phẩm và dịch
                    vụ cho bạn);</span></span></font>
            </font>
          </p>
        </li>
        <li>
          <p class="western" align="left"
            style="line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto">
            <font face="Times New Roman, serif">
              <font size="2" style="font-size: 9pt"><span lang="en-US"><span style="font-weight: normal">Chúng
                    tôi hoặc các thành viên của chúng tôi có bằng chứng
                    hợp lý hoặc nghi ngờ về tội phạm tài chính hoặc các
                    rủi ro liên quan.</span></span></font>
            </font>
          </p>
        </li>
      </ul>
      <p class="western" align="left"
        style="font-weight: normal; line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto">
        <br />

      </p>
      <p class="western" align="left"
        style="line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto">
        <font face="Times New Roman, serif">
          <font size="2" style="font-size: 9pt"><span lang="en-US"><b>(11).Xóa
                tài khoản và dữ liệu</b></span></font>
        </font>
      </p>
      <p class="western" align="left"
        style="line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto">
        <font face="Times New Roman, serif">
          <font size="2" style="font-size: 9pt"><span lang="en-US"><span style="font-weight: normal">VayDễ
                hiểu tầm quan trọng của việc người dùng kiểm soát
                thông tin cá nhân của mình và chúng tôi tôn trọng quyền
                yêu cầu xóa thông tin tài khoản của bạn. Người dùng
                có thể thực hiện yêu cầu xóa thông tin tài khoản trực
                tiếp trong ứng dụng VayDễ và gỡ cài đặt ứng dụng.
                Ngoài ra, người dùng cũng có thể liên hệ với địa chỉ
                email của chúng tôi (amanda@ptstarkapro.com) để chính thức
                gửi yêu cầu xóa dữ liệu. Sau khi thông tin tài khoản
                của người dùng bị xóa, dữ liệu liên quan sẽ không
                thể khôi phục được. VayDễ sẽ không sao lưu dữ liệu
                cho tài khoản này. Nếu muốn sử dụng lại dịch vụ
                VayDễ, bạn cần phải đăng ký lại.</span></span></font>
        </font>
      </p>
      <p class="western" align="left"
        style="line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto">
        <font face="Times New Roman, serif">
          <font size="2" style="font-size: 9pt"><span lang="en-US"><span style="font-weight: normal">Chúng
                tôi hiểu bạn và cam kết nỗ lực không ngừng để nâng
                cao chất lượng dịch vụ nhằm đáp ứng nhu cầu của
                bạn. VayDễ cam kết duy trì và bảo vệ quyền riêng tư,
                bảo mật của người dùng, đảm bảo thông tin cá nhân
                của bạn được xử lý rõ ràng. Nếu bạn có bất kỳ
                câu hỏi nào khác về vấn đề này, vui lòng liên hệ với
                chúng tôi và chúng tôi sẽ cố gắng hết sức để cung
                cấp hỗ trợ (liên hệ: amanda@ptstarkapro.com) và chúng tôi
                sẽ cố gắng hết sức để giúp bạn.</span></span></font>
        </font>
      </p>
      <p class="western" align="left"
        style="font-weight: normal; line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto">
        <br />

      </p>
      <p class="western" align="left"
        style="line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto">
        <font face="Times New Roman, serif">
          <font size="2" style="font-size: 9pt"><span lang="en-US"><b>(12).Bảo
                vệ trẻ vị thành niên</b></span></font>
        </font>
      </p>
      <p class="western" align="left"
        style="line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto">
        <font face="Times New Roman, serif">
          <font size="2" style="font-size: 9pt"><span lang="en-US"><span style="font-weight: normal">Chúng
                tôi rất coi trọng quyền riêng tư và sự an toàn của trẻ
                vị thành niên. Trong các ứng dụng của chúng tôi, trẻ
                vị thành niên nên thận trọng khi sử dụng dịch vụ và
                hoạt động dưới sự hướng dẫn của cha mẹ hoặc
                người giám hộ. Để bảo vệ thông tin cá nhân của trẻ
                vị thành niên, chúng tôi tuân thủ nghiêm ngặt các luật
                và quy định có liên quan để đảm bảo rằng thông tin
                của họ sẽ không được thu thập, lưu trữ hoặc sử
                dụng mà không được phép.</span></span></font>
        </font>
      </p>
      <p class="western" align="left"
        style="line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto">
        <font face="Times New Roman, serif">
          <font size="2" style="font-size: 9pt"><span lang="en-US"><span style="font-weight: normal">Chúng
                tôi sẽ không chủ động thu thập, sử dụng hoặc tiết
                lộ bất kỳ thông tin cá nhân nào từ trẻ vị thành niên
                mà không có sự đồng ý của cha mẹ hoặc người giám
                hộ hợp pháp. Nếu chúng tôi phát hiện ra rằng người
                dùng có thể là trẻ vị thành niên và đã cung cấp thông
                tin cá nhân mà không có sự đồng ý của cha mẹ hoặc
                người giám hộ, chúng tôi sẽ thực hiện các bước ngay
                lập tức để xóa thông tin đó và đình chỉ tài khoản
                của họ. Chúng tôi khuyến khích phụ huynh và người giám
                hộ thường xuyên xem xét các hoạt động trực tuyến của
                con mình để đảm bảo chúng hiểu được hậu quả của
                hành vi trực tuyến và tạo môi trường an toàn cho chúng
                sử dụng Internet.</span></span></font>
        </font>
      </p>
      <p class="western" align="left"
        style="line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto">
        <font face="Times New Roman, serif">
          <font size="2" style="font-size: 9pt"><span lang="en-US"><span style="font-weight: normal">Để
                bảo vệ tính bảo mật dữ liệu của trẻ vị thành
                niên, chúng tôi đã áp dụng một loạt biện pháp quản
                lý và kỹ thuật, chẳng hạn như mã hóa dữ liệu, kiểm
                soát truy cập và lọc nội dung. Ngoài ra, trẻ vị thành
                niên có quyền yêu cầu xóa thông tin cá nhân của mình để
                đảm bảo quyền riêng tư được bảo vệ đúng cách.
                Chúng tôi tin rằng việc bảo vệ quyền riêng tư và sự
                an toàn của trẻ vị thành niên là trách nhiệm của mọi
                nhà phát triển ứng dụng và chúng tôi sẽ tiếp tục nỗ
                lực để cung cấp trải nghiệm kỹ thuật số an toàn hơn
                cho trẻ vị thành niên.</span></span></font>
        </font>
      </p>
      <p class="western" align="left"
        style="font-weight: normal; line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto">
        <br />

      </p>
      <p class="western" align="left"
        style="line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto">
        <font face="Times New Roman, serif">
          <font size="2" style="font-size: 9pt"><span lang="en-US"><b>(13).Nhà
                phát triển công ty/giới thiệu cá nhân</b></span></font>
        </font>
      </p>
      <p class="western" align="left"
        style="line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto">
        <font face="Times New Roman, serif">
          <font size="2" style="font-size: 9pt"><span lang="en-US"><span style="font-weight: normal">VayDễ
                là sản phẩm dịch vụ vay vốn được phát triển bởi
                PT STARKA PRO INDONESIA và cam kết mang đến cho người dùng
                dịch vụ vay vốn hiệu quả, an toàn và tiện lợi. Mục
                tiêu của chúng tôi là giúp người dùng dễ dàng nhận ra
                nhu cầu tài chính của mình và cải thiện chất lượng
                cuộc sống thông qua đổi mới công nghệ và dịch vụ
                chất lượng cao. Giá trị cốt lõi của PT STARKA PRO
                INDONESIA là:</span></span></font>
        </font>
      </p>
      <p class="western" align="left"
        style="line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto">
        <font face="Times New Roman, serif">
          <font size="2" style="font-size: 9pt"><span lang="en-US"><span style="font-weight: normal">1.
                Tính chính trực: Chúng tôi hứa sẽ cung cấp cho người
                dùng thông tin khoản vay minh bạch và công bằng, đồng
                thời đảm bảo rằng người dùng hiểu tất cả các điều
                khoản và điều kiện.</span></span></font>
        </font>
      </p>
      <p class="western" align="left"
        style="line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto">
        <font face="Times New Roman, serif">
          <font size="2" style="font-size: 9pt"><span lang="en-US"><span style="font-weight: normal">2.
                Đổi mới: Không ngừng khám phá và áp dụng các công
                nghệ tiên tiến để cải thiện trải nghiệm người dùng
                và hiện thực hóa quy trình cho vay thông minh.</span></span></font>
        </font>
      </p>
      <p class="western" align="left"
        style="line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto">
        <font face="Times New Roman, serif">
          <font size="2" style="font-size: 9pt"><span lang="en-US"><span style="font-weight: normal">3.
                Người dùng là trên hết: luôn đặt nhu cầu của người
                dùng lên hàng đầu và cung cấp các giải pháp tài chính
                được cá nhân hóa.</span></span></font>
        </font>
      </p>
      <p class="western" align="left"
        style="line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto">
        <font face="Times New Roman, serif">
          <font size="2" style="font-size: 9pt"><span lang="en-US"><span style="font-weight: normal">Đội
                ngũ của PT STARKA PRO INDONESIA bao gồm một nhóm các chuyên
                gia có nền tảng tài chính và công nghệ phong phú. Chúng
                tôi có đội ngũ R&amp;D kỹ thuật hiệu quả, các nhà
                phân tích thị trường nhạy bén và đội ngũ dịch vụ
                khách hàng nhiệt tình, cùng nhau làm việc để cung cấp
                cho người dùng trải nghiệm dịch vụ tốt nhất. Nếu
                bạn có bất kỳ câu hỏi nào về ứng dụng hoặc dịch
                vụ cho vay của chúng tôi, vui lòng liên hệ với chúng tôi
                (thông tin liên hệ: amanda@ptstarkapro.com).</span></span></font>
        </font>
      </p>
      <p class="western" align="left"
        style="font-weight: normal; line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto">
        <br />

      </p>
      <p class="western" align="left"
        style="line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto">
        <font face="Times New Roman, serif">
          <font size="2" style="font-size: 9pt"><span lang="en-US"><b>(14).Kỳ
                vọng và sự phát triển trong tương lai</b></span></font>
        </font>
      </p>
      <p class="western" align="left"
        style="line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto">
        <font face="Times New Roman, serif">
          <font size="2" style="font-size: 9pt"><span lang="en-US"><span style="font-weight: normal">Trong
                lĩnh vực công nghệ tài chính đang thay đổi nhanh chóng,
                PT STARKA PRO INDONESIA Technology Co., Ltd. sẽ tiếp tục tuân
                thủ các nguyên tắc đổi mới và người dùng là trên
                hết, đồng thời tiếp tục phát triển theo các hướng
                sau:</span></span></font>
        </font>
      </p>
      <p class="western" align="left"
        style="line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto">
        <font face="Times New Roman, serif">
          <font size="2" style="font-size: 9pt"><span lang="en-US"><span style="font-weight: normal">1.
                Đổi mới công nghệ: Chúng tôi sẽ tiếp tục đầu tư
                vào nghiên cứu phát triển, sử dụng trí tuệ nhân tạo
                và công nghệ phân tích dữ liệu lớn để tối ưu hóa
                hơn nữa quy trình xét duyệt tín dụng, nâng cao hiệu quả
                phê duyệt và khả năng kiểm soát rủi ro. Thông qua deep
                learning và machine learning, chúng tôi hy vọng có thể đánh
                giá chính xác rủi ro tín dụng của người dùng và cung
                cấp các sản phẩm cho vay phù hợp hơn cho nhiều người
                dùng hơn.</span></span></font>
        </font>
      </p>
      <p class="western" align="left"
        style="line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto">
        <font face="Times New Roman, serif">
          <font size="2" style="font-size: 9pt"><span lang="en-US"><span style="font-weight: normal">2.
                Đa dạng hóa sản phẩm: Chúng tôi dự định mở rộng
                các loại hình sản phẩm vay để đáp ứng nhu cầu đa
                dạng của nhiều đối tượng người dùng. Ví dụ, các
                khu vực đặc biệt cho các khoản vay nhỏ, cho vay tiêu
                dùng, cho vay doanh nghiệp, v.v. đã được ra mắt để giúp
                người dùng có thể lựa chọn phương án vay phù hợp
                nhất tùy theo hoàn cảnh của mình.</span></span></font>
        </font>
      </p>
      <p class="western" align="left"
        style="line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto">
        <font face="Times New Roman, serif">
          <font size="2" style="font-size: 9pt"><span lang="en-US"><span style="font-weight: normal">3.
                Cải thiện trải nghiệm người dùng: Trải nghiệm người
                dùng là điều chúng tôi luôn chú trọng. Trong tương lai,
                chúng tôi sẽ tiếp tục tối ưu hóa thiết kế giao diện
                Ứng dụng, đơn giản hóa quy trình thao tác, tăng cường
                khả năng tương tác và mang đến cho người dùng trải
                nghiệm mượt mà hơn. Đồng thời, chúng tôi cải thiện
                hơn nữa sự hài lòng của người dùng bằng cách thiết
                lập một hệ thống dịch vụ khách hàng hoàn chỉnh, lắng
                nghe phản hồi của người dùng và giải quyết kịp thời
                các vấn đề của người dùng.</span></span></font>
        </font>
      </p>
      <p class="western" align="left"
        style="line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto">
        <font face="Times New Roman, serif">
          <font size="2" style="font-size: 9pt"><span lang="en-US"><span style="font-weight: normal">4.
                Phát triển bền vững: Chúng tôi sẽ chú ý đến bảo vệ
                môi trường và trách nhiệm xã hội, đồng thời thực
                hành khái niệm bền vững trong khi phát triển. Trong tương
                lai, chúng tôi có kế hoạch hỗ trợ các dự án bền vững
                thông qua công nghệ tài chính, thúc đẩy phát triển nền
                kinh tế xanh và phúc lợi xã hội, đồng thời mang lại
                lợi ích cho xã hội.</span></span></font>
        </font>
      </p>
      <p class="western" align="left"
        style="font-weight: normal; line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto">
        <br />

      </p>
      <p class="western" align="left"
        style="line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto">
        <font face="Times New Roman, serif">
          <font size="2" style="font-size: 9pt"><span lang="en-US"><span style="font-weight: normal">Thông
                qua chiến lược phát triển trên, PT STARKA PRO INDONESIA hy
                vọng sẽ viết nên một chương mới trong lĩnh vực công
                nghệ tài chính và mang đến những dịch vụ cho vay tiện
                lợi, hiệu quả hơn cho người dùng. Chúng tôi tin tưởng
                chắc chắn rằng với sự nỗ lực chung của toàn thể
                nhân viên, chúng tôi sẽ đạt được các mục tiêu dài
                hạn hơn và trở thành công ty dẫn đầu đáng tin cậy
                trong ngành.</span></span></font>
        </font>
      </p>
      <p class="western" align="left" style="line-height: 100%; margin-bottom: 0in">
        <br />

      </p>
      <p class="western" align="left"
        style="line-height: 100%; page-break-inside: auto; orphans: 0; widows: 0; margin-bottom: 0in; page-break-before: auto; page-break-after: auto">
        <font face="Times New Roman, serif">
          <font size="2" style="font-size: 9pt"><span lang="en-US"><b>(15).Liên
                hệ với chúng tôi</b></span></font>
        </font>
      </p>
      <p class="western" align="left" style="line-height: 100%; margin-bottom: 0in">
        <font face="Times New Roman, serif">
          <font size="2" style="font-size: 9pt"><span lang="en-US"><span style="font-weight: normal">Nếu
                bạn có bất kỳ câu hỏi nào về Chính sách quyền riêng
                tư này, vui lòng liên hệ với chúng tôi theo địa chỉ
                amanda@ptstarkapro.com. Vui lòng báo cáo việc không tuân thủ
                càng chi tiết càng tốt (bao gồm nhưng không giới hạn ở
                tên và tên tài khoản, ngày và giờ hành động, khiếu
                nại của bạn, mô tả lỗi và mã tham chiếu, tên và địa
                chỉ liên hệ bao gồm cả địa chỉ email, v.v.) Điều
                kiện của Chính sách quyền riêng tư này.</span></span></font>
        </font>
      </p>
      <p class="western" align="left" style="line-height: 100%; margin-bottom: 0in">
        <font face="Times New Roman, serif">
          <font size="2" style="font-size: 9pt"><span lang="en-US"><span style="font-weight: normal">Email:
              </span></span></font>
        </font>
        <font color="#000000">
          <font face="Times New Roman, serif">
            <font size="2" style="font-size: 9pt"><span lang="en-US"><span style="text-decoration: none"><span
                    style="font-weight: normal">amanda@ptstarkapro.com</span></span></span></font>
          </font>
        </font>
      </p>
      <p class="western" align="left" style="line-height: 100%; margin-bottom: 0in">
        <font face="Times New Roman, serif">
          <font size="2" style="font-size: 9pt"><span lang="en-US">Địa
              chỉ: 280 Đ. Thạch Bàn, Thạch Bàn, Long Biên, Hà Nội,
              Việt Nam</span></font>
        </font>
      </p>
    </div>
    <footerBox></footerBox>
  </div>
</template>
<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";
export default {
  name: "reservation",
  components: {
    menuBox,
    footerBox,
  },
  data() {
    return {
    };
  },
  mounted() { },
  methods: {
    sendInfo() {
      alert('ส่งเรียบร้อยแล้ว')
    }
  },
};
</script>
<style lang="less" scoped>
.reservation-box {
  background: #F4F8FB;

  .content-top {
    padding: 200px 312px 0;
    background-image: url(../assets/projects.png);
    width: 100%;
    height: 640px;
    background-size: 100% 100%;
    overflow: hidden;
    box-sizing: border-box;
    text-align: center;

    .title {
      margin-bottom: 20px;
      font-weight: bold;
      font-size: 56px;
      color: #FFFFFF;
      line-height: 79px;
    }

    .text {
      font-weight: bold;
      font-size: 24px;
      color: #E5D806;
      line-height: 33px;
    }
  }
}

.content {
  padding: 100px 312px;
  background: #1E1D21;
  font-size: 18px;
  color: #FFFFFF;
  line-height: 40px;
}
</style>
